export * from './duracion.pipe';
export * from './vacio.pipe';
export * from './domseguro.pipe';
export * from './estado-viaje-to-string.pipe';
export * from './estado-viaje-to-icon-name.pipe';
export * from './estado-tarea-to-string.pipe';
